import { moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, Inject, OnInit } from '@angular/core';
import { DIALOG_DATA, isLargeScreen } from '../../../../global.variable';
import { CheckpointService } from '../../../pages/pages/checkpoints/checkpoint.service';
import { LoadingSpinnerService } from '../../services/loading-spinner.service';
import { DialogRef } from '../modal-dialogue/modal-dialogue.ref';

@Component({
  selector: 'gtapp-add-checkpoint-route',
  standalone: false,
  templateUrl: './add-checkpoint-route.component.html',
  styleUrl: './add-checkpoint-route.component.scss',
})
export class AddCheckpointRouteComponent implements OnInit {
  largeView = isLargeScreen;

  patrolRouteCPList: any = [];
  patrolRouteCpTotalCount: number = 0;

  selectedCheckpoints: any = [];

  patrolCpFilterValue: any;
  cpSiteFilter: any = {};
  patrolCPCursor: string = '';

  checkpointSearchTimeoutFn: any;
  lastAddedCheckpointID: string = '';
  checkpointAddedTimeoutFn: any;

  updateFutureShifts: boolean = true;
  showUpdateFutureShifts: any;

  constructor(
    @Inject(DIALOG_DATA) public dialogData: any,
    protected dialogRef: DialogRef,
    private checkpointService: CheckpointService,
    private spinnerService: LoadingSpinnerService,
  ) {}

  ngOnInit(): void {
    this.selectedCheckpoints = this.dialogData?.selectedCheckpoints || [];
    this.cpSiteFilter = this.dialogData?.cpSiteFilter || {};
    this.showUpdateFutureShifts =
      this.dialogData?.showUpdateFutureShifts || this.showUpdateFutureShifts;

    this.updateFutureShifts = this.showUpdateFutureShifts;

    this.getCheckpointsCount();
    this.getFreshCheckpoints();
  }
  getCheckpointsCount() {
    let params: any = { get_count: 1 };
    if (this.cpSiteFilter?.id) params['site_id'] = this.cpSiteFilter?.id;
    this.checkpointService
      .listCheckpointData(params)
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.patrolRouteCpTotalCount = response?.total_size;
        }
      });
  }

  getPatrolRouteCheckpoints(loadMore = false) {
    let params: any = { rows: 10, cursor_based_pagination: 1 };

    if (this.patrolCpFilterValue?.length > 2) {
      params['search_str'] = this.patrolCpFilterValue;
    }
    if (this.patrolCPCursor) {
      params['next_cursor'] = this.patrolCPCursor;
    }

    if (this.cpSiteFilter?.id) params['site_id'] = this.cpSiteFilter?.id;
    this.checkpointService
      .listCheckpointData(params)
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.patrolCPCursor = response?.next_cursor;
          if (loadMore) {
            this.patrolRouteCPList.push(...response['data']);
            const seen = new Set();

            this.patrolRouteCPList = this.patrolRouteCPList?.filter(
              (item: any) => {
                if (seen.has(item?.id)) return false;
                seen.add(item?.id);
                return true;
              },
            );
          } else {
            this.patrolRouteCPList = response['data'];
          }

          this.spinnerService.hide();
        }
      });
  }
  onLoadMore() {
    this.getPatrolRouteCheckpoints(true);
  }
  removeSelectedCP(selectedIndex: number) {
    this.lastAddedCheckpointID = '';
    this.selectedCheckpoints = this.selectedCheckpoints?.filter(
      (checkpoint: any, index: number) => index !== selectedIndex,
    );
  }

  addSelectedCP(addCheckpoint: any) {
    this.lastAddedCheckpointID = '';

    if (this.selectedCheckpoints?.length < 250) {
      this.selectedCheckpoints.push(addCheckpoint);

      setTimeout(() => {
        this.lastAddedCheckpointID = addCheckpoint?.id;
        const lastElement: any = document.getElementById('lastElementAnchor');
        if (lastElement) {
          lastElement.scrollIntoView({
            behavior: 'smooth',
            block: 'end',
            inline: 'nearest',
          });
        }
      }, 50);
      if (this.checkpointAddedTimeoutFn)
        clearTimeout(this.checkpointAddedTimeoutFn);
      this.checkpointAddedTimeoutFn = setTimeout(() => {
        this.lastAddedCheckpointID = '';
      }, 1500);
    }
  }
  addAllCheckpoints() {
    this.patrolRouteCPList?.forEach((checkpoint: any) =>
      this.addSelectedCP(checkpoint),
    );
  }
  searchCheckPoints(event?: any) {
    this.patrolCpFilterValue = event.target.value;
    if (event.target.value?.length > 1) {
      if (this.checkpointSearchTimeoutFn)
        clearTimeout(this.checkpointSearchTimeoutFn);
      this.checkpointSearchTimeoutFn = setTimeout(() => {
        this.getFreshCheckpoints();
      }, 750);
    } else if (!event.target.value?.length) {
      this.patrolRouteCPList = [];
      this.getFreshCheckpoints();
    }
  }

  getFreshCheckpoints() {
    this.patrolCPCursor = '';
    this.getPatrolRouteCheckpoints();
  }
  dropNewCheckPoint(event: any) {
    moveItemInArray(
      this.selectedCheckpoints,
      event.previousIndex,
      event.currentIndex,
    );
  }
  onDialogClose(update = false) {
    this.dialogRef.close({
      selectedCheckpoints: update ? this.selectedCheckpoints : update,
      updateFutureShifts: this.updateFutureShifts
        ? this.showUpdateFutureShifts
        : 0,
    });
  }
}
